import {
    CommentDto,
    CreateCommentRequest,
    LoanApplicationBackofficeAPIApiGetCommentsForBackofficeRequest,
} from 'src/generated-api-client';
import { loanApplicationsApi } from 'src/services/apiServices';
import { ListFilter } from 'src/utils/FormHelper';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { FilterCriteria } from 'src/utils/mobx/FilterCriteria';
import { Pager } from 'src/utils/mobx/Pager';
import { Sorter, SorterDirection } from 'src/utils/mobx/Sorter';
import { RequestHelper } from 'src/utils/RequestHelper';

type LoanApplicationCommentsFilter =
    ListFilter<LoanApplicationBackofficeAPIApiGetCommentsForBackofficeRequest>;

export type LoanApplicationCommentForCreate = CreateCommentRequest & {
    id: string;
};

export class LoanApplicationCommentsStoreClass extends BasicStore<
    CommentDto,
    LoanApplicationCommentsFilter,
    unknown,
    LoanApplicationCommentForCreate,
    CommentDto
> {
    pager = new Pager();
    sorter = new Sorter<CommentDto>(['createdAt', SorterDirection.DESC]);
    filterCriteria = new FilterCriteria<LoanApplicationCommentsFilter>();

    api: BasicStoreApi<
        CommentDto,
        unknown,
        LoanApplicationCommentForCreate,
        CommentDto
    > = {
        loadList: async (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            const response = await RequestHelper.unwrapFromAxiosPromise(
                loanApplicationsApi.getCommentsForBackoffice(
                    {
                        ...this.filterCriteria.filter,
                        page: this.pager.page,
                        size: this.pager.size,
                        sort: this.sorter.sort,
                    },
                    options,
                ),
            );
            this.pager?.setTotal(response.totalElements ?? 0);

            return response.content ?? [];
        },
        createItem: async ({ id, ...data }, options) => {
            const response = await RequestHelper.unwrapFromAxiosPromise(
                loanApplicationsApi.addCommentForBackoffice(
                    {
                        id,
                        createCommentRequest: data,
                    },
                    options,
                ),
            );

            return response ?? null;
        },
    };
}

// Shared singleton instance of LoanApplicationComments store
export const LoanApplicationCommentsStore =
    new LoanApplicationCommentsStoreClass();
